import React from 'react';
import {Field, ErrorMessage} from 'formik';
import TextError from './TextError';

function Textarea(props) {
    const {label, name,height, ...rest} = props
    return(
        <div>
            <label htmlFor={name} style={{display:'block', width: '100%'}}>{label}</label>
            <Field as='textarea' id={name} name={name} height={height||'70px'} style={{display:'block', 
            width: '100%', height:height, padding:'5px', borderRadius:'3px', border:'1px solid black'}} {...rest} />
            <ErrorMessage name={name} component={TextError} />
        </div>
    )
}

export default Textarea
